"use strict";
// tslint:disable
// eslint-disable
/**
 * API Key Management API
 * API for CRUDing API Keys
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var ApiKeysApi = /** @class */ (function (_super) {
    __extends(ApiKeysApi, _super);
    function ApiKeysApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an API Key.
     */
    ApiKeysApi.prototype.createKeyRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.apiKey === null || requestParameters.apiKey === undefined) {
                            throw new runtime.RequiredError('apiKey', 'Required parameter requestParameters.apiKey was null or undefined when calling createKey.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/api_keys",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ApiKeyToJSON(requestParameters.apiKey),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ApiKeyFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create an API Key.
     */
    ApiKeysApi.prototype.createKey = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createKeyRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a specific API key.
     */
    ApiKeysApi.prototype.deleteKeyRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.keyId === null || requestParameters.keyId === undefined) {
                            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling deleteKey.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/api_keys/{keyId}".replace("{" + "keyId" + "}", encodeURIComponent(String(requestParameters.keyId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ApiKeyFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete a specific API key.
     */
    ApiKeysApi.prototype.deleteKey = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteKeyRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a single key for the current user.
     */
    ApiKeysApi.prototype.getKeyRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.keyId === null || requestParameters.keyId === undefined) {
                            throw new runtime.RequiredError('keyId', 'Required parameter requestParameters.keyId was null or undefined when calling getKey.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/api_keys/{keyId}".replace("{" + "keyId" + "}", encodeURIComponent(String(requestParameters.keyId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ApiKeyFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a single key for the current user.
     */
    ApiKeysApi.prototype.getKey = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getKeyRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get metadata about API Keys. Note that only keys owned by the currently authenticated user will be listed.
     */
    ApiKeysApi.prototype.getKeysRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.sortBy !== undefined) {
                            queryParameters['sortBy'] = requestParameters.sortBy;
                        }
                        if (requestParameters.sortOrder !== undefined) {
                            queryParameters['sortOrder'] = requestParameters.sortOrder;
                        }
                        if (requestParameters.seek !== undefined) {
                            queryParameters['seek'] = requestParameters.seek;
                        }
                        if (requestParameters.nameSearch !== undefined) {
                            queryParameters['nameSearch'] = requestParameters.nameSearch;
                        }
                        if (requestParameters.includeDeleted !== undefined) {
                            queryParameters['includeDeleted'] = requestParameters.includeDeleted;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/api_keys",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ApiKeyFromJSON); })];
                }
            });
        });
    };
    /**
     * Get metadata about API Keys. Note that only keys owned by the currently authenticated user will be listed.
     */
    ApiKeysApi.prototype.getKeys = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getKeysRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ApiKeysApi;
}(runtime.BaseAPI));
exports.ApiKeysApi = ApiKeysApi;
/**
    * @export
    * @enum {string}
    */
var GetKeysSortByEnum;
(function (GetKeysSortByEnum) {
    GetKeysSortByEnum["LastUsedAt"] = "last_used_at";
    GetKeysSortByEnum["CreatedAt"] = "created_at";
    GetKeysSortByEnum["DeletedAt"] = "deleted_at";
    GetKeysSortByEnum["Name"] = "name";
})(GetKeysSortByEnum = exports.GetKeysSortByEnum || (exports.GetKeysSortByEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetKeysSortOrderEnum;
(function (GetKeysSortOrderEnum) {
    GetKeysSortOrderEnum["Asc"] = "asc";
    GetKeysSortOrderEnum["Desc"] = "desc";
})(GetKeysSortOrderEnum = exports.GetKeysSortOrderEnum || (exports.GetKeysSortOrderEnum = {}));
